import React, { useState, useCallback } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { registerLocale } from 'react-datepicker';
import ko from 'date-fns/locale/ko';
import 'moment/locale/ko';
import styled from 'styled-components';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  PieChart,
  Pie,
  Sector,
  Cell,
  Label,
} from 'recharts';
import CustomTable from '../../components/CustomTable';
interface DataItem {
  name: string;
  value: number;
}

const Analysis = () => {
  const [tabType, setTabType] = useState<string>('time');
  const [selectType, setSelectType] = useState<number>(0);
  const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#000'];

  const data: DataItem[] = [
    { name: '아메리카노 A', value: 400 },
    { name: '아메리카노 B', value: 300 },
    { name: '아메리카노 C', value: 300 },
    { name: '아메리카노 D', value: 200 },
    { name: '아메리카노 E', value: 200 },
  ];
  const productList: any = [
    {
      date: '2024-01-18 10:00:00',
      product: '옥수수 감자 고구마 무말랭이옥수수 감자 고구마 무말랭이',
      price: '3000원',
      discount: '0원',
      orderStatus: '완료',
    },
    {
      date: '2024-01-18 10:00:00',
      product: '옥수수 감자 무말랭이',
      price: '80000원',
      discount: '3000원',
      orderStatus: '완료',
    },
    {
      date: '2024-01-18 10:00:00',
      product: '옥수수 감자 고구마 무말랭이',
      price: '300원',
      discount: '100원',
      orderStatus: '완료',
    },
    {
      date: '2024-01-18 10:00:00',
      product: '옥수수 무말랭이',
      price: '4000원',
      discount: '4000원',
      orderStatus: '완료',
    },
  ];
  const datas = [
    {
      name: '0시',
      uv: 4000,
      pv: 2400,
      amt: 2400,
    },
    {
      name: '3시',
      uv: 3000,
      pv: 1398,
      amt: 2210,
    },
    {
      name: '6시',
      uv: 2000,
      pv: 9800,
      amt: 2290,
    },
    {
      name: '12시',
      uv: 2780,
      pv: 3908,
      amt: 2000,
    },
    {
      name: '15시',
      uv: 1890,
      pv: 4800,
      amt: 2181,
    },
    {
      name: '18시',
      uv: 2390,
      pv: 3800,
      amt: 2500,
    },
    {
      name: '21시',
      uv: 3490,
      pv: 4300,
      amt: 2100,
    },
  ];

  function TimeSales() {
    return (
      <div className="timeSalesWrap">
        <div className="mainTitle">
          <div className="item">
            <div className="title pointer">주문이 가장 많이 들어온 시간대</div>
            <div className="time">19:00</div>
            <div className="count">총 30건</div>
          </div>
          <div className="item">
            <div className="title">주문이 가장 적게 들어온 시간대</div>
            <div className="time">10:00</div>
            <div className="count">총 2건</div>
          </div>
        </div>
        <div className="chartWrap">
          <h1>결제금액</h1>
          <ResponsiveContainer width="100%" height={250}>
            <AreaChart data={datas} syncId="anyId">
              <CartesianGrid vertical={false} />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Area type="monotone" dataKey="uv" stroke="#8884d8" fill="#8884d8" />
            </AreaChart>
          </ResponsiveContainer>
        </div>
        <div className="chartWrap">
          <h1>결제건수</h1>
          <ResponsiveContainer width="100%" height={250}>
            <AreaChart data={datas} syncId="anyId">
              <CartesianGrid vertical={false} />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Area type="monotone" dataKey="pv" stroke="#82ca9d" fill="#82ca9d" />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </div>
    );
  }

  function ProductSales() {
    const [activeIndex, setActiveIndex] = useState<any>(null);

    const onPieEnter = useCallback((_: any, index: number) => {
      setActiveIndex(index);
    }, []);
    const renderActiveShape = (props: any) => {
      const RADIAN = Math.PI / 180;
      const {
        cx,
        cy,
        midAngle,
        innerRadius,
        outerRadius,
        startAngle,
        endAngle,
        fill,
        payload,
        percent,
        value,
        name,
      } = props;
      const sin = Math.sin(-RADIAN * midAngle);
      const cos = Math.cos(-RADIAN * midAngle);
      const sx = cx + (outerRadius + 5) * cos;
      const sy = cy + (outerRadius + 5) * sin;
      const mx = cx + (outerRadius + 10) * cos;
      const my = cy + (outerRadius + 10) * sin;
      const ex = mx + (cos >= 0 ? 1 : -1) * 11;
      const ey = my;
      const textAnchor = cos >= 0 ? 'start' : 'end';

      return (
        <g>
          <text x={cx} y={cy} dy={5} textAnchor="middle" fill={fill}>
            {payload.name}
          </text>
          <Sector
            cx={cx}
            cy={cy}
            innerRadius={innerRadius}
            outerRadius={outerRadius}
            startAngle={startAngle}
            endAngle={endAngle}
            fill={fill}
          />
          <Sector
            cx={cx}
            cy={cy}
            startAngle={startAngle}
            endAngle={endAngle}
            innerRadius={outerRadius + 2}
            outerRadius={outerRadius + 6}
            fill={fill}
          />
          <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill="none" />
          <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
          <text
            x={ex + (cos >= 0 ? 1 : -1) * 4}
            y={ey}
            textAnchor={textAnchor}
            fontSize={'12px'}
            width={'100%'}
            fill="#333">{`${name}`}</text>
          <text
            x={ex + (cos >= 0 ? 1 : -1) * 5}
            y={ey}
            dy={18}
            textAnchor={textAnchor}
            fill="#999"
            fontSize={'12px'}>
            {`(${(percent * 50).toFixed(2)}%)`}
          </text>
        </g>
      );
    };
    return (
      <div>
        <div className="chartWrap">
          <h1>인기상품별 순위</h1>
          <div className="bestTitle">
            <div className="badge">TOP1</div>
            <h2>아메리카노</h2>
            <p>총 30건</p>
          </div>
          <div className="pieChartWrap">
            <ResponsiveContainer
              width={'100%'}
              height={'100%'}
              aspect={(window.innerWidth < 900 ? 1.8 : 1.3) / 1.0}
              style={{ flex: 1 }}>
              <PieChart onMouseEnter={onPieEnter}>
                <Pie
                  data={data}
                  cx={window.innerWidth < 900 ? '35%' : '50%'}
                  cy={window.innerWidth < 900 ? '50%' : '40%'}
                  innerRadius={'55%'}
                  outerRadius={'70%'}
                  fill="#8884d8"
                  paddingAngle={1}
                  dataKey="value"
                  onMouseEnter={onPieEnter}
                  activeIndex={activeIndex}
                  activeShape={(props: any) => renderActiveShape(props)}>
                  {data.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Pie>
              </PieChart>
            </ResponsiveContainer>
            <div className="chartListWrap">
              <div className="chartList">
                <p>2</p>
                <p>커피</p>
                <p>10건</p>
                <p>100,000원</p>
              </div>
              <div className="chartList">
                <p>3</p>
                <p>커피</p>
                <p>10건</p>
                <p>100,000원</p>
              </div>
              <div className="chartList">
                <p>4</p>
                <p>커피</p>
                <p>10건</p>
                <p>100,000원</p>
              </div>
              <div className="chartList">
                <p>5</p>
                <p>커피</p>
                <p>10건</p>
                <p>100,000원</p>
              </div>
            </div>
          </div>
        </div>
        <div className="chartWrap">
          <h1>인기 카테고리별 순위</h1>
          <div className="bestTitle">
            <div className="badge">TOP1</div>
            <h2>아메리카노</h2>
            <p>총 30건</p>
          </div>
          <div className="pieChartWrap">
            <ResponsiveContainer
              width={'100%'}
              height={'100%'}
              aspect={(window.innerWidth < 900 ? 1.8 : 1.3) / 1.0}
              style={{ flex: 1 }}>
              <PieChart onMouseEnter={onPieEnter}>
                <Pie
                  data={data}
                  cx={window.innerWidth < 900 ? '35%' : '50%'}
                  cy={window.innerWidth < 900 ? '50%' : '40%'}
                  innerRadius={'55%'}
                  outerRadius={'70%'}
                  fill="#8884d8"
                  paddingAngle={1}
                  dataKey="value"
                  onMouseEnter={onPieEnter}
                  activeIndex={activeIndex}
                  activeShape={(props: any) => renderActiveShape(props)}>
                  {data.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Pie>
              </PieChart>
            </ResponsiveContainer>
            <div className="chartListWrap">
              <div className="chartList">
                <p>2</p>
                <p>커피</p>
                <p>10건</p>
                <p>50,000원</p>
              </div>
              <div className="chartList">
                <p>3</p>
                <p>정말 맛있는 원두 커피</p>
                <p>10건</p>
                <p>100,000원</p>
              </div>
              <div className="chartList">
                <p>4</p>
                <p>커피</p>
                <p>10건</p>
                <p>100,000원</p>
              </div>
              <div className="chartList">
                <p>5</p>
                <p>커피</p>
                <p>10건</p>
                <p>10,000,000원</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // CustomTable
  const tableHeader = ['순서', '결제시간', '주문내역', '총거래금액', '할인금액', '주문상태'];
  const renderTableItem = () => {
    return (
      <>
        {productList.length > 0 ? (
          productList.map((item: any, index: number) => (
            <div key={index} className="listContent">
              <p>{index + 1}</p>
              <p>{item.date}</p>
              <p>{item.product}</p>
              <p>{item.price}</p>
              <p>{item.discount}</p>
              <p>{item.orderStatus}</p>
            </div>
          ))
        ) : (
          <p>조회된 날짜에 결제 내역이 없습니다.</p>
        )}
      </>
    );
  };

  return (
    <Style>
      <div className={`contentContainer ${tabType === 'product' && 'product'}`}>
        <div className="TabWrap">
          <div
            className={`tabBox ${tabType === 'time' && 'active'}`}
            onClick={() => setTabType('time')}>
            시간대별
            <div className={`tabBar ${tabType === 'time' && 'active'}`} />
          </div>
          <div
            className={`tabBox ${tabType === 'product' && 'active'}`}
            onClick={() => setTabType('product')}>
            상품별
            <div className={`tabBar ${tabType === 'product' && 'active'}`} />
          </div>
        </div>

        <div className="header">
          <div className="selectBoxWrap">
            <div
              className={`selectBox left ${selectType === 0 && 'active'}`}
              onClick={() => setSelectType(0)}>
              오늘
            </div>
            <div
              className={`selectBox center ${selectType === 1 && 'active'}`}
              onClick={() => setSelectType(1)}>
              이번주
            </div>
            <div
              className={`selectBox right ${selectType === 2 && 'active'}`}
              onClick={() => setSelectType(2)}>
              조회기간
            </div>
          </div>
          <button className="excelDownload">
            <p>엑셀파일 다운로드</p>
          </button>
        </div>
        <div className="content">{tabType === 'time' && <TimeSales />}</div>
        <div className="content">{tabType === 'product' && <ProductSales />}</div>
      </div>
      {tabType === 'product' && (
        <div className="contentContainer list">
          <div className="chartWrap">
            <h1>인기상품별 순위</h1>
            <CustomTable tableHeader={tableHeader} renderTableItem={renderTableItem} />
          </div>
          <div className="chartWrap" style={{ marginTop: '100px' }}>
            <h1>인기 카테고리별 순위</h1>
            <CustomTable tableHeader={tableHeader} renderTableItem={renderTableItem} />
          </div>
        </div>
      )}
    </Style>
  );
};

export default Analysis;

const Style = styled.div`
  /* contentContainer */
  .contentContainer:nth-child(2) {
    border-top-right-radius: 0;
    border-top-left-radius: 0;
  }
  .contentContainer.product {
    padding-bottom: 0;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
  /* TabWrap */
  .TabWrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    /* gap: 10px; */
  }
  .tabBox {
    flex: 1;
    text-align: center;
    font-size: 20px;
    font-weight: 600;
    color: #979797;
    cursor: pointer;
  }
  .tabBox.active {
    color: #4dd2ae;
  }
  .tabBar {
    width: 101%;
    height: 6px;
    position: relative;
    margin-top: 19px;
    background: #f7f7f7;
    border-radius: 5px;
    z-index: 0;
  }
  .tabBar.active {
    background: #4dd2ae;
    border-radius: 5px;
    z-index: 1;
  }

  /* header */
  .header {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 29px;
  }
  /* selectBoxWrap */
  .selectBoxWrap {
    display: flex;
    align-items: center;

    .selectBox {
      flex: 1;
      border: 1px solid #cecece;
      background: #fff;
      font-size: 16px;
      color: #979797;
      padding: 12px 0;
      text-align: center;
      cursor: pointer;
    }
    .selectBox.left {
      border-radius: 5px 0px 0px 5px;
    }
    .selectBox.right {
      border-radius: 0px 5px 5px 0px;
    }
    .selectBox.center {
      margin: 0 -1px;
    }
    .selectBox.active {
      border: 1px solid #4dd2ae;
      background: #ecf5f3;
      color: #40977f;
      z-index: 2;
    }
  }
  /* excelDownload */
  .excelDownload {
    margin-left: auto;
    margin-top: 20px;
    padding: 6px 20px;
    background: #f7f7f7;
    border: 1px solid #979797;
    border-radius: 5px;

    p {
      font-size: 14px;
      font-weight: 600;
      color: #555;
    }
  }

  /* 시간대별 */
  .mainTitle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 50px 0;
    gap: 5px;

    .item {
      flex: 1;
      text-align: center;

      .title {
        display: inline-block;
        margin-bottom: 20px;
        padding: 6px 12px;
        border: 1px solid #e5e5e5;
        border-radius: 50px;
        font-size: 16px;
        font-weight: 600;
        color: #979797;
      }
      .title.pointer {
        color: #ff7e7e;
      }
      .time {
        margin-bottom: 6px;
        font-size: 28px;
        font-weight: 600;
        color: #555;
      }
      .count {
        font-size: 16px;
        font-weight: 500;
        color: #cecece;
      }
    }
  }

  /* chartWrap */
  .chartWrap {
    margin-bottom: 10%;
    h1 {
      margin-bottom: 20px;
      font-size: 16px;
      font-weight: 600;
      color: #555;
    }
  }
  .pieChartWrap {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    .pieChart {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .chartListWrap {
    flex: 1;
    width: 100%;

    .chartList {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;

      p {
        font-size: 16px;
        font-weight: 500;
        color: #555;
        text-align: center;
      }
      p:nth-child(1) {
        flex: 0 0 5%;
        width: 5%;
      }
      p:nth-child(2) {
        flex: 0 0 40%;
        width: 40%;
        text-align: left;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      p:nth-child(3) {
        flex: 0 0 15%;
        width: 15%;
      }
      p:nth-child(4) {
        flex: 0 0 35%;
        width: 35%;
        text-align: right;
      }
    }
  }
  .bestTitle {
    display: inline-block;
    text-align: center;

    .badge {
      display: inline-block;
      padding: 2px 10px;
      border: 1px solid #cecece;
      font-size: 12px;
      font-weight: 600;
      color: #ff7e7e;
      border-radius: 50px;
    }
    h2 {
      margin: 10px 0 6px 0;
      font-size: 28px;
      font-weight: 600;
      color: #555;
    }
    p {
      font-size: 16px;
      font-weight: 500;
      color: #cecece;
    }
  }

  /* listWrap */
  .listTitle h2,
  .listContent p {
    text-align: center;
  }
  .listTitle h2:nth-child(1),
  .listContent p:nth-child(1) {
    flex: 0 0 5%;
    width: 5%;
    text-align: center;
  }
  .listTitle h2:nth-child(2),
  .listContent p:nth-child(2) {
    flex: 0 0 25%;
    width: 25%;
    text-align: center;
  }
  .listTitle h2:nth-child(3),
  .listContent p:nth-child(3) {
    flex: 0 0 23%;
    width: 23%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .listContent p:nth-child(3) {
    text-align: left;
  }
  .listTitle h2:nth-child(4),
  .listContent p:nth-child(4) {
    flex: 0 0 15%;
    width: 15%;
  }
  .listTitle h2:nth-child(5),
  .listContent p:nth-child(5) {
    flex: 0 0 15%;
    width: 15%;
  }
  .listTitle h2:nth-child(6),
  .listContent p:nth-child(6) {
    flex: 0 0 10%;
    width: 10%;
  }

  @media (max-width: 900px) {
    .pieChartWrap {
      flex-direction: column;
    }
  }
`;
